import { Tabs } from '@chakra-ui/react'
import { useStore } from '@tanstack/react-store'
import { getAccess } from 'features/Private'
import { ROLES } from 'shared/constants/user'
import { authStore } from 'shared/store/auth'
import { userCardStore } from 'shared/store/userCard'
import { UserEditEkengHistory } from './UserEditEkengHistory'
import { UserEditForm } from './UserEditForm'
import { UserEditFormInternal } from './UserEditFormInternal'
import { UserEditHistory } from './UserEditHistory'

export const UserEdit = ({ userId }) => {
  const { user } = useStore(authStore)
  const userCard = useStore(userCardStore)
  const hasEkeng = !!userCard?.ekengData

  const isAdmin = getAccess(user.roles, [ROLES.admin])

  return (
    <Tabs.Root mb="50px" variant="subtle" colorPalette="orange" size="sm" defaultValue="main">
      <Tabs.List>
        {isAdmin && <Tabs.Trigger value="main">Главная</Tabs.Trigger>}
        {isAdmin && <Tabs.Trigger value="additional">Дополнительно</Tabs.Trigger>}
        <Tabs.Trigger value="history">История</Tabs.Trigger>
        {hasEkeng && <Tabs.Trigger value="ekeng-history">История Ekeng</Tabs.Trigger>}
      </Tabs.List>
      {isAdmin && (
        <Tabs.Content value="main">
          <UserEditForm />
        </Tabs.Content>
      )}
      {isAdmin && (
        <Tabs.Content value="additional">
          <UserEditFormInternal />
        </Tabs.Content>
      )}
      <Tabs.Content value="history">
        <UserEditHistory userId={userId} />
      </Tabs.Content>
      {hasEkeng && (
        <Tabs.Content value="ekeng-history">
          <UserEditEkengHistory userId={userId} />
        </Tabs.Content>
      )}
    </Tabs.Root>
  )
}
